export const UNAUTHORIZED = "UNAUTHORIZED"
export const NOT_FOUND = "NOT_FOUND"
export const FORM_ERROR = "FORM_ERROR"
export const OTHER_ERROR = "OTHER_ERROR"